import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentBadge32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconDocumentBadge32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M24 25a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-1h7a3 3 0 0 0 3-3v-1a3 3 0 0 0-3-3H8V7a2 2 0 0 1 2-2h6v8h8zM6 17.17V7a4 4 0 0 1 4-4h7.172a2 2 0 0 1 1.414.586l6.828 6.828A2 2 0 0 1 26 11.828V25a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4v-1.17A3 3 0 0 1 4 21v-1c0-1.306.835-2.418 2-2.83M7 19a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM18 5.828V11h5.172z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentBadge32);
